module.exports = __webpack_public_path__ + "img/kitkat.a2356406.png";